import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { StructureEditor } from 'react-ocl/full';
import CloseButton from '../../elements/CloseButton';
import { ModalStyles } from '../../modal/ModalStyle';
export function DatabaseStructureSearchModal({ onChange, idCode, onClose, }) {
    return (_jsxs("div", { css: ModalStyles, children: [_jsxs("div", { className: "header handle", children: [_jsx("span", { children: "Search by structure" }), _jsx(CloseButton, { onClick: onClose, className: "close-bt" })] }), _jsx("div", { className: "main-content", children: _jsx(StructureEditor, { initialIDCode: idCode, svgMenu: true, fragment: true, onChange: (mplFile, molecule, idCode) => onChange(idCode) }) })] }));
}
